import { LegalScreen } from '@/components/legal/LegalScreen'

// The signup RPC records account ToS v1.3. Never send this link to a newer
// rental version unless the signup signature is versioned in the same change.
export default function SignupTermsRoute() {
  return <LegalScreen slug="terms-of-service" frozenAccountTerms />
}
